var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskGpt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 8.6875C16.1227 10.7588 15.2989 12.7446 13.8343 14.2093C12.3696 15.6739 10.3838 16.4977 8.3125 16.5H1.75C1.41848 16.5 1.10054 16.3683 0.866116 16.1339C0.631696 15.8995 0.5 15.5815 0.5 15.25V8.6875C0.5 6.6155 1.3231 4.62836 2.78823 3.16323C4.25336 1.6981 6.2405 0.875 8.3125 0.875C10.3845 0.875 12.3716 1.6981 13.8368 3.16323C15.3019 4.62836 16.125 6.6155 16.125 8.6875Z",
    fill: "#3AB1F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskGpt1);
export default __webpack_public_path__ + "static/media/Ask GPT1.2eb23fd01a9ddc119bef680c155530f1.svg";
export { ForwardRef as ReactComponent };